import { render } from "./nav-link.vue?vue&type=template&id=e46b398e"
import script from "./nav-link.vue?vue&type=script&lang=js"
export * from "./nav-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__